<template>
    <div>
        <button class="btn btn-warning btn-lg center-block"                
                @click="signDocument()">
            Sign the Document
        </button>

        <div class="modal fade in" 
             tabindex="-1" 
             ref="modal" 
             role="dialog" 
             id="signDocumentModal" 
             data-backdrop="false"
             v-show="showModal"
             :class="{signDocumentModalVisible : showModal}"
             transition="expand">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header is-success">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><i class="fa fa-pencil"></i>&nbsp;Sign the Document</h4>
                    </div>

                    <div class="modal-body">
                        <div class="row" v-show="checkingSignature">
                            <div class="col-md-12">
                                <p>Checking your signature&nbsp;<i class="fa fa-spinner fa-spin" aria-hidden="true"></i></p>
                            </div>
                        </div>
                        <div class="row" v-show="savingSignature">
                            <div class="col-md-12">
                                <p>{{savingSignatureMsg}}&nbsp;<i class="fa fa-spinner fa-spin" aria-hidden="true"></i></p>
                            </div>
                        </div>
                        <div class="row" v-show="newSignature && !checkingSignature && !savingSignature">
                            <!-- <div class="col-md-12">
                                <strong><p>You don't have a Signature yet, please create it below:</p></strong>
                            </div> -->
                            <div class="col-md-12 well">
                                <p>You can sign this document by drawing your own signature below:</p>
                                <canvas id="signatureCanvas" 
                                        width="525" 
                                        height="100">
                                </canvas>
                                <button style="float:left" 
                                        class="btn btn--def btn-info btn-xs" 
                                        data-dismiss="modal"
                                        @click="createNewSignature()">
                                        New Signature
                                </button>
                                <button v-show="newSignature"
                                        style="float:left; margin-left:5px;" 
                                        class="btn btn--def btn-info btn-xs" 
                                        data-dismiss="modal"
                                        @click="clearSignature()">
                                        <i class="fa fa-eraser"></i>Clear
                                </button>
                                <button style="float:right" 
                                        class="btn btn--def btn-primary btn-xs" 
                                        id="btn-sign-document-confirm"
                                        @click="saveSignature()">
                                        <i class="fa fa-pencil"></i>&nbsp;Sign it with the drawn signature above
                                </button>
                            </div>
                            
                            <div class="col-md-12 well">
                                <p>You can sign this document by selecting a font for your name below: </p>
                                <canvas id="signatureCanvasText" 
                                        width="525" 
                                        height="100">
                                </canvas>
                                <button v-show="newSignature"
                                        style="float:left;" 
                                        class="btn btn--def btn-info btn-xs" 
                                        data-dismiss="modal"
                                        @click="changeFont()">
                                        <i class="fa fa-refresh"></i>&nbsp;Change Font
                                </button>
                                <button style="float:right" 
                                        class="btn btn--def btn-primary btn-xs" 
                                        id="btn-sign-document-confirm"
                                        @click="saveSignatureText()">
                                        <i class="fa fa-pencil"></i>&nbsp;Sign it with the text above
                                </button>
                            </div>
                            
                        </div>
                        <div class="row" v-show="!newSignature && !checkingSignature && !savingSignature">
                            <div class="col-md-12">
                                <p>You already have a registered signature. Just click "sign it" for continue the process!</p>
                            </div>
                        </div>
                        <div class="row" v-show="signingDocument">
                            <div class="col-md-12">
                                <center><p>Signing the document...&nbsp;<i class="fa fa-spinner fa-spin" aria-hidden="true"></i></p></center>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-footer">
                        <button style="float:left" 
                                class="btn btn--def btn-danger btn-xs" 
                                data-dismiss="modal"
                                @click="closeModal()">
                                Close
                        </button>
                        <button style="float:left" 
                                class="btn btn--def btn-info btn-xs" 
                                data-dismiss="modal"
                                @click="createNewSignature()">
                                Create a new Signature
                        </button>
                        <button v-show="!newSignature && !checkingSignature && !savingSignature"
                                style="float:right" 
                                class="btn btn--def btn-primary btn-xs" 
                                id="btn-sign-document-confirm"
                                @click="saveSignature()">
                                <i class="fa fa-pencil"></i>&nbsp;Sign it
                        </button>
                        <!-- <button v-show="newSignature"
                                style="float:left" 
                                class="btn btn--def btn-info" 
                                data-dismiss="modal"
                                @click="clearSignature()">
                                <i class="fa fa-eraser"></i>Clear
                        </button> -->
                        <!-- <button style="float:right" 
                                class="btn btn--def btn-primary" 
                                id="btn-sign-document-confirm"
                                @click="saveSignature()">
                                <i class="fa fa-pencil"></i>&nbsp;Sign it
                        </button> -->
                    </div>
                </div>
            </div>
        </div> 
        <!-- end of domain connection modal -->
    </div>
</template>

<script>
    import qs from 'qs';
    import SignaturePad from 'signature_pad';

    export default {
        name: "sign-document",
        props: [
            'type',
            'targetform'
        ],
        mounted() {
            // console.log('signature mounted');
            // console.log(this.type);
        },
        data() {
            return {
                showModal : false,
                option    :{
                    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                canvas                : null,
                // canvasText            : null,
                // canvasTextCtx         : null,
                signaturePad            : null,
                signaturesCheckingURL   : `/us/office/tax-forms/${this.type}/check-signature`,
                signatureSaveURL        : `/us/office/tax-forms/${this.type}/save-signature`,
                signaturesCheckingURLPF : `/us/office/privacy-form/check-signature`,
                signatureSaveURLPF      : `/us/office/privacy-form/save-signature`,
                newSignature            : false,
                checkingSignature       : false,
                savingSignature         : false,
                savingSignatureMsg      : 'Saving Signature',
                signingDocument         : false,
                fontsOptions            : [
                    'Caveat',
                    'Roboto Condensed',
                    'Aguafina Script',
                    'Swanky and Moo Moo',
                    'Dancing Script',
                    'Shadows Into Light',
                    'Gloria Hallelujah',
                    'Courgette'
                ],
                fontSelected          : 0
            }
        },
        methods: {
            onBegin() {
                // console.log('=== Begin ===');
            },

            onEnd() {
                // console.log('=== End ===');
            },

            /**
             * Starts the Sign Document process
             */
            async signDocument() {
                this.checkingSignature = true;
                this.showModal = true;

                // this.scrollToTop();
                
                let id_user_office = document.querySelector('input[name=id_user_office]').value;
                let user_name      = document.querySelector('input[name=user_name]').value;
                if(this.type       == 'w8ben-e') user_name = document.querySelector('input[name=part_XXX_signer]').value;
                let form           = document.querySelector('#'+this.targetform);

                let checksignatureData = await this.checkSignature(id_user_office);

                this.checkingSignature = false;

                if(checksignatureData.status == false) {
                    this.newSignature = true;
                    this.canvas       = document.querySelector('#signatureCanvas');
                    this.signaturePad = new SignaturePad(this.canvas);
                }else {
                    this.newSignature = false;
                }

                this.fontSelected = 0
                // console.log('started with 1', this.fontsOptions[this.fontSelected]);

                let canvasText          = document.querySelector('#signatureCanvasText');
                let canvasTextCtx       = canvasText.getContext("2d");
                
                this.fontsOptions.forEach(function(item) {
                    canvasTextCtx.clearRect(0, 0, canvasText.width, canvasText.height);
                    canvasTextCtx.font      = "50px " + item;
                    canvasTextCtx.fillStyle = "black";
                    canvasTextCtx.textAlign = "center";
                    canvasTextCtx.fillText(user_name, 
                                            canvasText.width/2, 
                                            canvasText.height/1.5);
                    // console.log('changing to ', item);
                });

                // console.log('started with 2', this.fontsOptions[this.fontSelected]);
                canvasTextCtx.font      = "50px " + this.fontsOptions[this.fontSelected];
                
            },

            closeModal() {
                this.showModal    = false;
                this.signaturePad = null;
            },

            createNewSignature() {
                this.newSignature = true;
                this.canvas       = document.querySelector('#signatureCanvas');
                this.signaturePad = new SignaturePad(this.canvas);
                this.signaturePad.clear();

                let user_name = '';
                if(this.type == 'w9' || this.type == 'privacyForm') user_name      = document.querySelector('input[name=name]').value;
                if(this.type == 'w8ben') user_name     = document.querySelector('input[name=individual_name]').value;
                if(this.type == 'w8ben-e') user_name   = document.querySelector('input[name=part_XXX_signer]').value;

                this.refreshSignatureText(user_name);
            },

            clearSignature() {
                this.signaturePad.clear();
            },            

            async saveSignature() {

                let form = document.querySelector('#'+this.targetform);

                if(this.newSignature || this.checkingSignature || this.savingSignature) {
                    this.savingSignature = true;   
    
                    let signatureDataPNG      = this.signaturePad.toDataURL();
                    let signatureSavingResult = await this.saveSignatureToFile(signatureDataPNG);
                    this.savingSignature      = false;
                }

                this.signingDocument = true;

                // this.closeModal();
                let formValidated = false;
                if(this.type == 'w9') {
                    $('#'+this.targetform).validate();
                    if($('#'+this.targetform).valid() == true) formValidated = true;
                    
                    if(formValidated == true) {
                        let w9SocialEINValid = this.w9SocialEINValid();

                        if(w9SocialEINValid.status == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", w9SocialEINValid.message);
                            let errorEl = document.querySelector('input[name=' + w9SocialEINValid.errorEl + ']');
                            errorEl.focus();
                            return;
                        }  

                        let fullNameValid = this.fullNameValid('name');
                        if(fullNameValid == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", 'You need to inform a Full Name with at least two names.');
                            let errorEl = document.querySelector('input[name=' + 'name' + ']');
                            errorEl.focus();
                            return;
                        }
                    }
                } else if(this.type == 'w8ben') {
                    $('#'+this.targetform).validate();
                    if($('#'+this.targetform).valid() == true) formValidated = true;
                    
                    if(formValidated == true) {
                        let fullNameValid = this.fullNameValid('individual_name');
                        if(fullNameValid == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", 'You need to inform a Full Name with at least two names.');
                            let errorEl = document.querySelector('input[name=' + 'individual_name' + ']');
                            errorEl.focus();
                            return;
                        }
                    }
                    
                } else if(this.type == 'w8ben-e') {
                    if($('#'+this.targetform)[0].checkValidity() == true) formValidated = true;

                    if(formValidated == true) {
                        let fullNameValid = this.fullNameValid('part_XXX_signer');
                        if(fullNameValid == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", 'You need to inform a Full Name with at least two names.');
                            let errorEl = document.querySelector('input[name=' + 'part_XXX_signer' + ']');
                            errorEl.focus();
                            return;
                        }
                    }
                } else if(this.type == 'privacyForm') {
                    if($('#'+this.targetform)[0].checkValidity() == true) formValidated = true;

                }

                if(formValidated == true) {
                    form.submit();
                }else {
                    let errorList      = $('#'+this.targetform).validate().errorList;
                    let errorFieldsMsg = '';
                    
                    errorList.forEach(function(item) {
                        errorFieldsMsg += " - " + item.message + "<br>";
                    });

                    if(this.type == 'w8ben-e') {
                        errorFieldsMsg += "<br>- Please Verify if you have checked the last checkbox <i>'I certify that I have the capacity to sign for the entity identified on line 1 of this form.'</i> in the page #30 of this form. ";
                        errorFieldsMsg += "<br><br>- Verify if you have filled the field <i>'signer'</i> in the page #30 of this form. ";
                    }

                    this.signingDocument = false;
                    this.closeModal();
                    alertMsg("error", "Please check if you have filled correctly all the required fields:<br><br>" + errorFieldsMsg);
                }

            },

            w9SocialEINValid() {

                let name     = document.querySelector('input[name=name]').value.trim();
                let business = document.querySelector('input[name=business_name]').value.trim();
                let ssn      = document.querySelector('input[name=social_security_number]').value.trim();
                let ein      = document.querySelector('input[name=employer_identification_number]').value.trim();
                let status   = false;
                let message  = '';
                let errorEl  = '';

                if(business != '') {
                    if(ein != '' && ssn == '') {
                        status = true
                    }else if(ein == '' && ssn == '') {
                        status  = false;
                        message = 'As the Business Name is filled, you need to fill the Employer Identification Number.';
                        errorEl = 'employer_identification_number';
                    }else {
                        status  = false;
                        message = 'As the Business Name is filled, you need to remove the Social Security Number.';
                        errorEl = 'social_security_number';
                    }
                }else{
                    if(ein == '' && ssn != ''){
                        status = true;
                    }else {
                        status  = false;
                        message = 'As the Business Name is empty, you need to remove the Employer Identification Number.';
                        errorEl = 'employer_identification_number';
                    }
                }

                return {
                    status  : status,
                    message : message,
                    errorEl : errorEl
                }
            },

            fullNameValid(nameElement) {
                let name = document.querySelector('input[name=' + nameElement + ']').value.trim();
                
                if(name.split(' ').length < 2)  return false;
                if(name.split(' ').length >= 2) return true;
            },

            scrollToTop() {
                window.scrollTo(0,0);
            },

            /**
             * Check if there is already a signature created for this user
             * @param int id_user_office
             */
            async checkSignature(id_user_office) {       
                let requestData = {
                    id_user_office : id_user_office
                };

                let checksignatureData = await axios
                    .post(
                        this.type == 'privacyForm' ? this.signaturesCheckingURLPF : this.signaturesCheckingURL, 
                        qs.stringify(requestData)
                    )
                    .then(response => {
                        // console.log('response');
                        // console.log(response);
                        if (response.status == 200) {
                            return response.data;
                        }else{
                            throw new Error('Error Requesting Check Signature API ');
                        }
                    })
                    .catch(error => {
                        console.log("erro", error);
                        console.log("erro", error.response);
                    });


                return new Promise(resolve=> {
                    resolve(checksignatureData);
                });
            },

            async saveSignatureToFile(signatureDataPNG) {
                let requestData = {
                    imageData : signatureDataPNG
                };

                let saveSignatureData = await axios
                    .post(
                        this.type == 'privacyForm' ? this.signatureSaveURLPF : this.signatureSaveURL, 
                        qs.stringify(requestData)
                    )
                    .then(response => {
                        if (response.status == 200) {
                            return response.data;
                        }else{
                            throw new Error('Error Requesting Save Signature API ');
                        }
                    })
                    .catch(error => {
                        console.log("erro", error, error.response);
                    });


                return new Promise(resolve=> {
                    resolve(saveSignatureData);
                });
            },

            changeFont() {
                // console.log('changing the font');

                this.fontSelected++;
                if(this.fontSelected > (this.fontsOptions.length - 1)) this.fontSelected = 0;

                let user_name = '';
                if(this.type == 'w9' || this.type == 'privacy-form') user_name      = document.querySelector('input[name=name]').value;
                if(this.type == 'w8ben') user_name   = document.querySelector('input[name=individual_name]').value;
                if(this.type == 'w8ben-e') user_name = document.querySelector('input[name=part_XXX_signer]').value;

                let canvasText          = document.querySelector('#signatureCanvasText');
                let canvasTextCtx       = canvasText.getContext("2d");

                // console.log('changed to ', this.fontsOptions[this.fontSelected]);

                canvasTextCtx.clearRect(0, 0, canvasText.width, canvasText.height);
                canvasTextCtx.font      = "50px " + this.fontsOptions[this.fontSelected];
                canvasTextCtx.fillStyle = "black";
                canvasTextCtx.textAlign = "center";
                canvasTextCtx.fillText(user_name, 
                                        canvasText.width/2, 
                                        canvasText.height/1.5);
            },

            async saveSignatureText() {
                let form = document.querySelector('#'+this.targetform);

                if(this.newSignature || this.checkingSignature || this.savingSignature) {
                    this.savingSignature = true;   

                    let canvasText    = document.querySelector('#signatureCanvasText');
                    let imageTextDataPNG = canvasText.toDataURL();
    
                    let signatureSavingResult = await this.saveSignatureToFile(imageTextDataPNG);
                    this.savingSignature      = false;
                }

                this.signingDocument = true;

                // this.closeModal();
                let formValidated = false;
                if(this.type == 'w9') {
                    $('#'+this.targetform).validate();
                    if($('#'+this.targetform).valid() == true) formValidated = true;
                    
                    if(formValidated == true) {
                        let w9SocialEINValid = this.w9SocialEINValid();

                        if(w9SocialEINValid.status == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", w9SocialEINValid.message);
                            let errorEl = document.querySelector('input[name=' + w9SocialEINValid.errorEl + ']');
                            errorEl.focus();
                            return;
                        }
                        
                        let fullNameValid = this.fullNameValid('name');
                        if(fullNameValid == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", 'You need to inform a Full Name with at least two names.');
                            let errorEl = document.querySelector('input[name=' + 'name' + ']');
                            errorEl.focus();
                            return;
                        }
                    }
                } else if(this.type == 'w8ben') {
                    $('#'+this.targetform).validate();
                    if($('#'+this.targetform).valid() == true) formValidated = true;

                    if(formValidated == true) {
                        let fullNameValid = this.fullNameValid('individual_name');
                        if(fullNameValid == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", 'You need to inform a Full Name with at least two names.');
                            let errorEl = document.querySelector('input[name=' + 'individual_name' + ']');
                            errorEl.focus();
                            return;
                        }
                    }
                } else if(this.type == 'w8ben-e') {
                    if($('#'+this.targetform)[0].checkValidity() == true) formValidated = true;

                    if(formValidated == true) {
                        let fullNameValid = this.fullNameValid('part_XXX_signer');
                        if(fullNameValid == false) {
                            this.signingDocument = false;
                            this.closeModal();
                            alertMsg("error", 'You need to inform a Full Name with at least two names.');
                            let errorEl = document.querySelector('input[name=' + 'part_XXX_signer' + ']');
                            errorEl.focus();
                            return;
                        }
                    }
                } else if(this.type == 'privacyForm') {
                    if($('#'+this.targetform)[0].checkValidity() == true) formValidated = true;
                }

                if(formValidated == true) {
                    form.submit();
                }else {
                    let errorList      = $('#'+this.targetform).validate().errorList;
                    let errorFieldsMsg = '';
                    
                    errorList.forEach(function(item) {
                        errorFieldsMsg += " - " + item.message + "<br>";
                    });

                    if(this.type == 'w8ben-e') {
                        errorFieldsMsg += "<br>- Please Verify if you have checked the last checkbox <i>'I certify that I have the capacity to sign for the entity identified on line 1 of this form.'</i> in the page #30 of this form. ";
                        errorFieldsMsg += "<br><br>- Verify if you have filled the field <i>'signer'</i> in the page #30 of this form. ";
                    }

                    this.signingDocument = false;
                    this.closeModal();
                    alertMsg("error", "Please check if you have filled correctly all the required fields:<br><br>" + errorFieldsMsg);
                }

            },

            refreshSignatureText(userName) {
                this.fontSelected = 0
                // console.log('started with 1', this.fontsOptions[this.fontSelected]);

                let canvasText          = document.querySelector('#signatureCanvasText');
                let canvasTextCtx       = canvasText.getContext("2d");
                
                this.fontsOptions.forEach(function(item) {
                    canvasTextCtx.clearRect(0, 0, canvasText.width, canvasText.height);
                    canvasTextCtx.font      = "50px " + item;
                    canvasTextCtx.fillStyle = "black";
                    canvasTextCtx.textAlign = "center";
                    canvasTextCtx.fillText(userName, 
                                            canvasText.width/2, 
                                            canvasText.height/1.5);
                    // console.log('changing to ', item);
                });

                // console.log('started with 2', this.fontsOptions[this.fontSelected]);
                canvasTextCtx.font      = "50px " + this.fontsOptions[this.fontSelected];
            }
            
        }
    };

</script>

<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
    @import url('https://fonts.googleapis.com/css?family=Aguafina+Script');
    @import url('https://fonts.googleapis.com/css?family=Swanky+and+Moo+Moo');
    @import url('https://fonts.googleapis.com/css?family=Dancing+Script');
    @import url('https://fonts.googleapis.com/css?family=Gloria+Hallelujah');
    @import url('https://fonts.googleapis.com/css?family=Caveat');
    @import url('https://fonts.googleapis.com/css?family=Courgette');

    #signatureCanvas {
        border : 1px solid #DDD;
        background-color: #FFF;
    }

    #signatureCanvasText {
        border : 1px solid #DDD;
        background-color: #FFF;
    }
    // .sign-modal-content {
    //     padding: 10px;
    //     font-style: 13px;
    // }

    // .v--modal-overlay {
    //     height: 100% !important;
    // }

    .signDocumentModalVisible {
        display: block !important;
    }

    #signDocumentModal {
        top: -25px;
    }

    // .modal-mask {
    //     position: fixed;
    //     z-index: 9998;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 100%;
    //     background-color: rgba(0, 0, 0, .5);
    //     display: table;
    //     transition: opacity .3s ease;
    // }

    // .modal-wrapper {
    //     display: table-cell;
    //     vertical-align: middle;
    // }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/SignDocument.vue